import { mutatorAction } from 'satcheljs';
import { getRecentFilesStore } from '../store/RecentFilesStore';
import { FileListLoadingStatus } from '../Schema/FileListLoadingStatus';
import { getRecentFilesList } from '../selectors/getRecentFilesList';

const updateRecentFilesLoadingStatus = mutatorAction(
    'updateRecentFilesLoadingStatus',
    function updateRecentFilesLoadingStatus(
        groupSmtp: string,
        fileListLoadingStatus: FileListLoadingStatus
    ) {
        groupSmtp = groupSmtp.toLowerCase();
        const recentFilesStore = getRecentFilesStore();

        // Get the recent files list for the group, or a list with default values if group not found
        const currentRecentFilesList = getRecentFilesList(groupSmtp);

        // Update the loading status in the list
        currentRecentFilesList.fileListLoadingStatus = fileListLoadingStatus;

        // Update the loading status if group found in map, or add new entry to the recent files list map
        recentFilesStore.recentFilesPerGroup.set(groupSmtp, currentRecentFilesList);
    }
);

export default updateRecentFilesLoadingStatus;
